import { Skeleton } from 'primereact/skeleton';

export const APP_BASE_URL = 'https://api.nagraaccounting.com';
// export const APP_BASE_URL = 'https://tgwk9h35-5001.inc1.devtunnels.ms';
// export const APP_BASE_URL = "https://5a5a-2405-201-2000-f957-c036-f41f-5915-7d21.ngrok-free.app";

export const ASSET_PATH = APP_BASE_URL;

export const IMAGE_BASEURL = APP_BASE_URL + 'front/assets/img/search_image.png';

// PAGINATION
//default pagination Row data
export const defaultRowOptions = 100;

//default PerPageRow options
export const defaultPageRowOptions = [10, 25, 50, 100];

//paginatior entries showing
export const showingEntries = 'Showing {first} to {last} of {totalRecords}';

//paginator links & dropdown
export const paginatorLinks =
  'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown';

// Provinces
export const provinces = [
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Northwest Territories',
  'Nova Scotia',
  'Nunavut',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
  'Yukon',
];

//emilPattern
export const emailPattern = new RegExp(
  /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
);
// phone pattern
export const phonePattern = new RegExp(
  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
);

// postal code pattern
export const postalCodePattern =
  /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

// skeleton items & length
export const Skeletonitems: number[] = Array.from({ length: 10 }, (v, i) => i);

// SKELETON FOR COLUMN BODY
export function SkeletonbodyTemplate(): JSX.Element {
  return <Skeleton></Skeleton>;
}

// dynamic section header
export const getSectionHeaders = (isMarried: any) => {
  const headers = [
    {
      key: 'personal',
      label: 'Personal Information',
      // icon: "pi pi-user"
    },
    {
      key: 'employment',
      label: 'General Information',
      // icon: "pi pi-briefcase",
    },
    {
      key: 'general_questions',
      label: 'Other Income Information',
      // icon: "pi pi-briefcase",
    },
    {
      key: 'documents',
      label: 'Main Applicant Document',
      // icon: "pi pi-file"
    },
    // { key: "marital", label: "Marital Status", icon: "pi pi-heart" },
  ];

  if (isMarried) {
    headers.push({
      key: 'marital_document',
      label: 'Spouse Document',
      // icon: "pi pi-file",
    });
  }

  return headers;
};

// form status dropdown
export const needReviewStatusDropdown = [
  { label: 'Form Submitted', value: 'Form Submitted' },
  {
    label: 'Missing Document/Information',
    value: 'Missing Document/Information',
  },
  { label: 'Need Review', value: 'Need Review' },
  { label: 'Sign Pending', value: 'Sign Pending' },
  { label: 'Sign Done', value: 'Sign Done' },
  { label: 'Whatsapp', value: 'Whatsapp' },
  { label: 'Document Received', value: 'Document Received' },
  { label: 'Sign Done Whatsapp', value: 'Sign Done Whatsapp' },
  { label: 'Tax Filed', value: 'Tax Filed' },
  { label: 'Ready To File', value: 'Ready To File' },
];
export const baseDocTypes = [
  { label: 'T4 Of All The Jobs You Worked', value: 't4_file' },
  { label: 'Upload T2202A File', value: 't2202a_file' },
  { label: 'T4A Of All The Jobs You Worked', value: 't4a_file' },
  { label: 'Upload T5007 File', value: 't5007_file' },
  { label: 'Upload T5008 File', value: 't5008_file' },
  { label: 'Upload T5 File', value: 't5_file' },
  { label: 'Upload Uber Eats / DoorDash / SkipTheDishes', value: 'uber_file' },
  { label: 'Upload Other File', value: 'other_file' }
];
// canadian dropdown status
export const canadianStatusDropdown = [
  { label: 'Citizen', value: 'Citizen' },
  { label: 'Work permit holder', value: 'Work permit holder' },
  {
    label: 'Permenant resident',
    value: 'Permenant resident',
  },
  { label: 'Student', value: 'Student' },
  { label: 'Refugee', value: 'Refugee' },
  { label: 'Other', value: 'Other' },
];

// slot status template
export const slotStatusDropdown = [
  { label: 'Booked', value: true },
  { label: 'Pending', value: false },
];

// filling form for first time
export const fillingFormForFirstTime = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
];


export const gstOption = [
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Annual', value: 'Annual' },
  { label: 'N/A', value: 'N/A' }
];
export const WCBOptions = [
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Annual (31 Dec)', value: 'Annual' },
  { label: 'N/A', value: 'N/A' }
];

export const CompanyFilingStatusOptions = [
  { label: 'Pending', value: 'Pending' },
  { label: 'Done', value: 'Done' },
  { label: 'N/A', value: 'N/A' },
];

export const PendingFiledStatusOptions = [
  { label: 'Pending', value: 'Pending' },
  { label: 'Filed', value: 'Filed' }
];

export const CompanyDocumentStatusOptions = [
  { label: 'Pending', value: 'Pending' },
  { label: 'Received', value: 'Received' }
];

// user form clear field switch case
export const applyFieldRules = (
  name: string,
  val: any,
  updatedData: any,
  updatedErrors: any,
) => {
  switch (name) {
    case 'first_time_form_filling_status':
      if (val === '1') {
        updatedData.moved_from_province = '';
        updatedErrors.moved_from_province = '';
      } else {
        updatedData.income_from_home = '';
        updatedData.date_of_entry = '';
        updatedErrors.income_from_home = '';
        updatedErrors.date_of_entry = '';
      }
      updatedErrors.first_time_form_filling_status = '';
      break;

    case 'moved_from_province':
      if (val === '0') {
        updatedData.moving_date = '';
        updatedData.province_from = '';
        updatedData.province_to = '';
        updatedErrors.moving_date = '';
        updatedErrors.province_from = '';
        updatedErrors.province_to = '';
      }
      break;

    case 'benefit_status':
      if (val === '0') {
        delete updatedData.landlords;
        updatedErrors.landlords = '';
      } else {
        updatedData.landlords = updatedData.landlords;
      }
      break;

    case 'province':
      if (val !== 'Manitoba' && val !== 'British Columbia') {
        delete updatedData?.benefit_status;
        delete updatedErrors?.benefit_status;
        delete updatedData.landlords;
        updatedErrors.landlords = '';
      } else {
        updatedData.landlords = [{ name: '', amount: 0, months: '' }];
      }
      break;

    case 'self_employed_income':
      if (val == '0') {
        // Clear has_gst and gst_no
        delete updatedData?.has_gst;
        delete updatedErrors?.has_gst;
        delete updatedData?.gst_no;
        delete updatedErrors?.gst_no;
        delete updatedData?.self_employed_amount;
        delete updatedErrors?.self_employed_amount;

        // Clear all self-employed expense fields
        delete updatedData.gas_expense;
        delete updatedData.repairs_expense;
        delete updatedData.insurance_expense;
        delete updatedData.phone_bill_expenses;
        delete updatedData.meal_expenses;
        delete updatedData.car_model;
        delete updatedData.car_model_year;
        delete updatedData.car_purchase_year;
        delete updatedData.car_price_paid;

        // Clear errors for self-employed expense fields
        delete updatedErrors.gas_expense;
        delete updatedErrors.repairs_expense;
        delete updatedErrors.insurance_expense;
        delete updatedErrors.phone_bill_expenses;
        delete updatedErrors.meal_expenses;
        delete updatedErrors.car_model;
        delete updatedErrors.car_model_year;
        delete updatedErrors.car_purchase_year;
        delete updatedErrors.car_price_paid;

        // Clear other expenses array
        delete updatedData.employedOtherExpenses;
        updatedErrors.employedOtherExpenses = '';
      } else {
        updatedData.employedOtherExpenses = [{ name: '', amount: '' }];
      }
      break;

    case 'has_gst':
      if (val == '0') {
        delete updatedData?.gst_no;
        delete updatedErrors?.gst_no;
      }
      break;

    case 'spouse_self_employed_income':
      if (val == '0') {
        // Clear spouse_has_gst and gst_no
        delete updatedData?.spouse_has_gst;
        delete updatedErrors?.spouse_has_gst;
        delete updatedData?.spouse_gst_no;
        delete updatedErrors?.spouse_gst_no;
        delete updatedData?.spouse_self_employed_amount;
        delete updatedErrors?.spouse_self_employed_amount;

        // Clear all self-employed expense fields
        delete updatedData.spouse_gas_expense;
        delete updatedData.spouse_repairs_expense;
        delete updatedData.spouse_insurance_expense;
        delete updatedData.spouse_phone_bill_expenses;
        delete updatedData.spouse_meal_expenses;
        delete updatedData.spouse_car_model;
        delete updatedData.spouse_car_model_year;
        delete updatedData.spouse_car_purchase_year;
        delete updatedData.spouse_car_price_paid;

        // Clear errors for self-employed expense fields
        delete updatedErrors.spouse_gas_expense;
        delete updatedErrors.spouse_repairs_expense;
        delete updatedErrors.spouse_insurance_expense;
        delete updatedErrors.spouse_phone_bill_expenses;
        delete updatedErrors.spouse_meal_expenses;
        delete updatedErrors.spouse_car_model;
        delete updatedErrors.spouse_car_model_year;
        delete updatedErrors.spouse_car_purchase_year;
        delete updatedErrors.spouse_car_price_paid;

        // Clear other expenses array
        delete updatedData.spouseEmployedOtherExpenses;
        updatedErrors.spouseEmployedOtherExpenses = '';
      } else {
        updatedData.spouseEmployedOtherExpenses = [{ name: '', amount: '' }];
      }
      break;

    case 'spouse_has_gst':
      if (val == '0') {
        delete updatedData?.spouse_gst_no;
        delete updatedErrors?.spouse_gst_no;
      }
      break;

    case 'work_from_home':
      if (val == '0') {
        // Clear claim_expense field
        delete updatedData?.claim_expense;
        delete updatedErrors?.claim_expense;

        // Clear all WFH expense fields
        delete updatedData.internet_bill;
        delete updatedData.insurance_bill;
        delete updatedData.equipment_bill;
        delete updatedData.stationery_bill;
        delete updatedData.utilities_bill;
        delete updatedData.hydro_bill;
        delete updatedData.rent_bill;

        // Clear errors for WFH expense fields
        delete updatedErrors.internet_bill;
        delete updatedErrors.insurance_bill;
        delete updatedErrors.equipment_bill;
        delete updatedErrors.stationery_bill;
        delete updatedErrors.utilities_bill;
        delete updatedErrors.hydro_bill;
        delete updatedErrors.rent_bill;

        // Clear WFH other expenses array
        delete updatedData.wfhEmployedOtherExpenses;
        updatedErrors.wfhEmployedOtherExpenses = '';
      } else {
        // Initialize wfhEmployedOtherExpenses if not exists
        updatedData.wfhEmployedOtherExpenses = [{ name: '', amount: '' }];
      }
      break;

    case 'spouse_work_from_home':
      if (val == '0') {
        // Clear claim_expense field
        delete updatedData?.spouse_claim_expense;
        delete updatedErrors?.spouse_claim_expense;

        // Clear all WFH expense fields
        delete updatedData.spouse_internet_bill;
        delete updatedData.spouse_insurance_bill;
        delete updatedData.spouse_equipment_bill;
        delete updatedData.spouse_stationery_bill;
        delete updatedData.spouse_utilities_bill;
        delete updatedData.spouse_hydro_bill;
        delete updatedData.spouse_rent_bill;

        // Clear errors for WFH expense fields
        delete updatedErrors.spouse_internet_bill;
        delete updatedErrors.spouse_insurance_bill;
        delete updatedErrors.spouse_equipment_bill;
        delete updatedErrors.spouse_stationery_bill;
        delete updatedErrors.spouse_utilities_bill;
        delete updatedErrors.spouse_hydro_bill;
        delete updatedErrors.spouse_rent_bill;

        // Clear WFH other expenses array
        delete updatedData.spouseWfhEmployedOtherExpenses;
        updatedErrors.spouseWfhEmployedOtherExpenses = '';
      } else {
        // Initialize spouseWfhEmployedOtherExpenses if not exists
        updatedData.spouseWfhEmployedOtherExpenses = [{ name: '', amount: '' }];
      }
      break;

    case 'dec_marrige_status':
      if (val === 'Single') {
        delete updatedData.marrige_status_changed_date;
        delete updatedErrors.marrige_status_changed_date;

        delete updatedData.spouse_first_time_form_filling_status;
        delete updatedData.spouse_income_from_home;
        delete updatedErrors.spouse_first_time_form_filling_status;
        delete updatedErrors.spouse_income_from_home;

        delete updatedData.spouse_income_from_home;
        delete updatedData.spouse_sin_number;
        delete updatedData.spouse_email;
        delete updatedData.spouse_phone;
        delete updatedErrors.spouse_sin_number;
        delete updatedData.spouse_first_name;
        delete updatedData.spouse_last_name;
        delete updatedData.spouse_dob;

        // Clear spouse canadian resident field
        delete updatedData.is_spouse_canadian_resident;
        delete updatedErrors.is_spouse_canadian_resident;
      } else if (val !== 'Married' && val !== 'Living common-law') {
        delete updatedData.is_spouse_canadian_resident;
        delete updatedData.spouse_first_name;
        delete updatedData.spouse_last_name;
        delete updatedData.spouse_email;
        delete updatedData.spouse_phone;
        delete updatedData.spouse_sin_number;
        delete updatedData.spouse_dob;
        delete updatedData.spouse_income_from_home;
        delete updatedData.spouse_first_time_form_filling_status;
        delete updatedData.spouse_moved_from_province;
        delete updatedData.spouse_date_of_entry;
        delete updatedData.spouse_moving_date;
        delete updatedData.spouse_province_from;
        delete updatedData.spouse_province_to;
        delete updatedData.spouse_t5008_file;
        delete updatedData.spouse_t2202a_file;
        delete updatedData.spouse_t4_file;
        delete updatedData.spouse_t4a_file;
        delete updatedData.spouse_uber_file;
        delete updatedData.spouse_other_file;
        delete updatedData.spouse_t5007_file;
        delete updatedData.spouse_t5_file;
        delete updatedData.spouse_canadian_status;

        delete updatedErrors.is_spouse_canadian_resident;
        delete updatedErrors.spouse_first_name;
        delete updatedErrors.spouse_last_name;
        delete updatedErrors.spouse_email;
        delete updatedErrors.spouse_phone;
        delete updatedErrors.spouse_sin_number;
        delete updatedErrors.spouse_dob;
        delete updatedErrors.spouse_income_from_home;
        delete updatedErrors.spouse_first_time_form_filling_status;
        delete updatedErrors.spouse_moved_from_province;
        delete updatedErrors.spouse_date_of_entry;
        delete updatedErrors.spouse_moving_date;
        delete updatedErrors.spouse_province_from;
        delete updatedErrors.spouse_province_to;
        delete updatedErrors.spouse_t5008_file;
        delete updatedErrors.spouse_t2202a_file;
        delete updatedErrors.spouse_t4_file;
        delete updatedErrors.spouse_t4a_file;
        delete updatedErrors.spouse_uber_file;
        delete updatedErrors.spouse_other_file;
        delete updatedErrors.spouse_t5007_file;
        delete updatedErrors.spouse_t5_file;
        delete updatedErrors.spouse_canadian_status;
      }
      break;

    case 'is_spouse_canadian_resident':
      if (val === '1') {
        delete updatedData.spouse_first_time_form_filling_status;
        delete updatedData.spouse_income_from_home;
        updatedErrors.spouse_first_time_form_filling_status = '';
        updatedErrors.spouse_income_from_home = '';
      } else {
        delete updatedData.spouse_income_from_home;
        delete updatedData.spouse_sin_number;
        delete updatedData.spouse_email;
        delete updatedData.spouse_phone;
        delete updatedErrors.spouse_sin_number;
        delete updatedData.spouse_canadian_status;
        delete updatedErrors.spouse_canadian_status;
      }
      break;

    case 'spouse_first_time_form_filling_status':
      if (val === '1') {
        delete updatedData.spouse_moved_from_province;
        delete updatedData.spouse_moving_date;
        delete updatedData.spouse_province_from;
        delete updatedData.spouse_province_to;

        delete updatedErrors.spouse_moved_from_province;
        delete updatedErrors.spouse_moving_date;
        delete updatedErrors.spouse_province_from;
        delete updatedErrors.spouse_province_to;
      } else {
        updatedData.spouse_date_of_entry = '';
        updatedData.spouse_income_from_home = 0;
        updatedErrors.spouse_date_of_entry = '';
        updatedErrors.spouse_income_from_home = 0;
      }
      updatedErrors.spouse_first_time_form_filling_status = '';
      break;

    case 'spouse_moved_from_province':
      if (val === '0') {
        updatedData.spouse_moving_date = '';
        updatedData.spouse_province_from = '';
        updatedData.spouse_province_to = '';
        updatedErrors.spouse_moving_date = '';
        updatedErrors.spouse_province_from = '';
        updatedErrors.spouse_province_to = '';
      }
      break;

    case 'rental_income':
      if (val === '0') {
        delete updatedData.rental_amount;
        delete updatedData.bc_hydro_bill;
        delete updatedData.utilities;
        delete updatedData.repairs;
        delete updatedData.bank_interest;
        delete updatedData.property_tax;
        delete updatedData.insurance;
        delete updatedData.internet;
        delete updatedData.fortis_bc;
        delete updatedData.property_address;
        delete updatedData.property_owner_name;
        delete updatedData.share_of_property_owner;
        delete updatedData.generalOtherExpenses;
        delete updatedData.propertyOwnerNameAndShares;
      } else {
        updatedData.generalOtherExpenses = updatedData.generalOtherExpenses;
      }
      break;

    default:
      break;
  }
};
